import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

// MODULES
import app from './modules/app';
import articles from './modules/articles';
import auth from './modules/auth';
import cart from './modules/cart';
import hats from './modules/hats';
import patches from './modules/patches';
import user from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
  // enable strict mode in dev
  strict: process.env.NODE_ENV !== 'production',
  plugins: [
    createPersistedState({
      key: 'memerhats.com',
      storage: window.sessionStorage,
      paths: [
        'auth.comingSoonAccess',
        'auth.submissionsAccess',
        'user.currentUser',
      ],
    }),
  ],
  modules: {
    app,
    articles,
    auth,
    cart,
    hats,
    patches,
    user,
  },
});
